var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinIcon = function SvgLinkedinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0C7.611 0 0 7.611 0 17s7.611 17 17 17 17-7.611 17-17S26.389 0 17 0Zm5.25 8A3.75 3.75 0 0 1 26 11.75v10.5A3.75 3.75 0 0 1 22.25 26h-10.5A3.75 3.75 0 0 1 8 22.25v-10.5A3.75 3.75 0 0 1 11.75 8h10.5ZM14 22.25V14h-2.25v8.25H14Zm-1.125-11.847c.725 0 1.313.592 1.313 1.323 0 .73-.588 1.323-1.313 1.323a1.318 1.318 0 0 1-1.313-1.323c0-.73.588-1.323 1.313-1.323ZM15.5 14v8.25h2.25v-4.203c0-2.335 3-2.526 3 0v4.203H23v-5.07c0-3.939-4.203-3.796-5.25-1.856V14H15.5Z",
    fill: "#2C112D"
  })));
};
export default SvgLinkedinIcon;